<template>
  <div>
    <v-flex xs12>
      <h3 class="subheading my-2">{{ $t('addressData') }}</h3>
    </v-flex>
    <v-flex
      v-for="key in addressKeys"
      :key="key"
      xs12
    >
      <v-text-field
        v-model="card[key]"
        :error-messages="errorMessages[key]"
        :label="$t(key) + `${getValidationRules(key).length === 0 ? '' : '*'}`"
        :rules="getValidationRules(key)"
        :readonly="key === 'address_country'"
        class="mx-3"
      />
    </v-flex>
  </div>
</template>
<script>
export default {
  name: 'SubscriptionBaseData',
  props: [
    'addressKeys',
    'card',
    'errorMessages'
  ],
  methods: {
    getValidationRules (key) {
      if (key === 'address_line2') {
        return []
      }
      return [this.$rules.isRequired]
    }
  },
  i18n: {
    messages: {
      de: {
        name: 'Besitzer',
        company_name: 'Firmenname',
        addressData: 'Adresse',
        address_line1: 'Straße',
        address_line2: 'Addresszusatz',
        address_city: 'Stadt',
        address_state: 'Bundesland',
        address_zip: 'Postleitzahl',
        address_country: 'Land',
        country: 'Deutschland'
      },
      en: {
        name: 'Owner',
        company_name: 'Company name',
        addressData: 'Address',
        address_line1: 'Street',
        address_line2: 'c/o',
        address_city: 'Town',
        address_state: 'State',
        address_zip: 'Zip',
        address_country: 'Country',
        country: 'Germany'
      },
      tr: {
        name: 'Sahip',
        company_name: 'Şirket adı',
        addressData: 'Adres',
        address_line1: 'Sokak',
        address_line2: 'Ek Adres Satırı',
        address_city: 'Şehir',
        address_state: 'Bölge/Eyalet',
        address_zip: 'Posta kodu',
        address_country: 'Ülke',
        country: 'Almanya'
      },
      ru: {
        name: 'Владелец',
        addressData: 'Адрес',
        company_name: 'Название компании',
        address_line1: 'Адрес',
        address_line2: 'Адрес 2',
        address_city: 'Город',
        address_state: 'Штат',
        address_zip: 'ZIP-код',
        address_country: 'Страна',
        country: 'Германия'
      }
    }
  }
}
</script>
